import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OnboardingResearch = _resolveComponent("OnboardingResearch")
  const _component_Reasoning = _resolveComponent("Reasoning")

  return ($props.mode === 'onboarding')
    ? (_openBlock(), _createBlock(_component_OnboardingResearch, {
        key: 0,
        status: $props.reasoning
      }, null, 8 /* PROPS */, ["status"]))
    : (_openBlock(), _createBlock(_component_Reasoning, {
        key: 1,
        "chat-id": $props.chatId,
        reasoning: $props.reasoning,
        completed: $props.completed,
        onEnd: _cache[0] || (_cache[0] = $event => (_ctx.$emit('end')))
      }, null, 8 /* PROPS */, ["chat-id", "reasoning", "completed"]))
}